module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/products/products.component.css
// module id = ./src/app/products/products.component.css
// module chunks = main